<template>
  <div>
    <el-row
      type="flex"
      justify="flex-start"
      class="search-reports-row"
      :gutter="20"
    >
      <el-col v-for="i in inputs" :key="i.field" :xs="12" :sm="6" :lg="5">
        <el-input v-model="searchData[i.field]" :placeholder="i.text" />
      </el-col>
      <el-col :xs="12" :sm="6" :lg="5">
        <el-select
          v-model="searchData.status"
          placeholder="Статус отчета"
          clearable
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-col>
      <el-col :xs="12" :sm="6" :lg="5">
        <loader-wrapper :loading="isLoadingClients">
          <el-select
            v-model="searchData.org_client_id"
            filterable
            remote
            clearable
            placeholder="Заказчик"
            :remote-method="searchClient"
            @focus="getAllClients"
          >
            <el-option
              v-for="item in clientOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </loader-wrapper>
      </el-col>
      <el-col v-for="i in dates" :key="i.field" :xs="12" :sm="6" :lg="5">
        <el-date-picker
          v-model="searchData[i.field]"
          type="date"
          :placeholder="i.text"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
        />
      </el-col>
      <el-col :xs="12" :sm="6" :lg="5">
        <el-button type="primary" @click="onSearch">Поиск</el-button>
      </el-col>
      <el-col :xs="12" :sm="6" :lg="5">
        <el-button type="primary" plain @click="onClear">
          Сбросить фильтры
        </el-button>
      </el-col>
      <el-col :xs="12" :sm="6" :lg="4">
        <el-dropdown @command="handleAdditionalMenu">
          <el-button type="info" class="btn-dropdown btn-dop-menu" plain>
            ...
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item type="text" command="changeStatusModal">
              Сменить статус
            </el-dropdown-item>
            <el-dropdown-item type="text" command="addPayment">
              Добавить оплату
            </el-dropdown-item>
            <el-dropdown-item type="text" command="deleteReport">
              Удалить отчет
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
    <status-modal
      :open="isStatusModalOpen"
      :list="changeStatusList"
      @close-modal="isStatusModalOpen = false"
      @status-changed="changeModal('isStatusModalOpen')"
    />
    <payment-modal
      :open="isAddPaymentModalOpen"
      :report="addPaymentReport"
      @close-modal="isAddPaymentModalOpen = false"
      @payment-added="changeModal('isAddPaymentModalOpen')"
    />
  </div>
</template>

<script>
import { FETCH_REPORTS, SET_PAGINATION } from '@/store/actions/reports'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { dates, inputs, statusOptions } from '../../constants'
import { mapGetters, mapMutations } from 'vuex'
import { pickerOpt } from '@/datas/consts'
import LoaderWrapper from '@/components/Shared/LoaderWrapper'
import PaymentModal from './PaymentModal'
import StatusModal from './StatusModal'
import shippingMixin from '@/mixins/shippingMixin'

const Clients = RepositoryFactory.get('clients')
const ReportsAPI = RepositoryFactory.get('totalReport')

export default {
  name: 'Header',
  components: {
    LoaderWrapper,
    PaymentModal,
    StatusModal,
  },
  mixins: [shippingMixin],
  data() {
    return {
      inputs,
      statusOptions,
      dates,
      pickerOptions: pickerOpt,
      clientOptions: [],
      searchData: {
        id: '',
        status: '',
        load_point: '',
        author: '',
        org_client_id: '',
      },
      isStatusModalOpen: false,
      changeStatusList: [],
      isAddPaymentModalOpen: false,
      addPaymentReport: null,
      reportClients: [],
      isLoadingClients: false,
    }
  },
  computed: {
    ...mapGetters({
      reportsList: 'reports/getReports',
      checkedList: 'reports/getReportsPageChecked',
    }),
    hasSearchData() {
      for (let key in this.searchData) {
        if (this.searchData[key]) {
          return true
        }
      }

      return false
    },
    clientsList() {
      return this.reportClients.map(item => ({
        id: item.id,
        name: item.short_name,
      }))
    },
  },
  async created() {
    this.isLoadingClients = true
    const { data } = await Clients.getList({ perPage: 999 })

    this.reportClients = data.items
    this.isLoadingClients = false
  },
  methods: {
    ...mapMutations({
      setCheckedList: 'reports/setReportsPageChecked',
      clearReports: `reports/${FETCH_REPORTS}`,
      clearPagination: `reports/${SET_PAGINATION}`,
    }),
    // удаленный поиск клиентов по мере ввода строки
    searchClient(query) {
      if (query !== '') {
        this.clientOptions = this.clientsList.filter(
          item => item.name.toLowerCase().indexOf(query.toLowerCase()) > -1,
        )
      } else {
        this.clientOptions = []
      }
    },
    // для отображения в списке селекта при первоначальном фокусе берем всех
    getAllClients() {
      this.clientOptions = this.clientsList
    },
    onSearch() {
      this.reloadReportsList()
    },
    onClear() {
      this.searchData = {
        id: '',
        status: '',
        load_point: '',
        author: '',
        org_client_id: '',
      }
      this.reloadReportsList()
    },
    handleAdditionalMenu(command) {
      this[command]()
    },
    // открытие модалки смены статуса
    changeStatusModal() {
      if (this.checkedList.length) {
        this.changeStatusList = this.reportsList.filter(
          item => this.checkedList.indexOf(item.id) !== -1,
        )
        this.isStatusModalOpen = true
      } else {
        this.$message.error('Ошибка! Не выбран ни один документ.')
      }
    },
    // открытие модалки добавления оплаты по отчету
    addPayment() {
      if (this.checkedList.length === 1) {
        this.isAddPaymentModalOpen = true
        this.addPaymentReport = this.reportsList.find(
          item => item.id === this.checkedList[0],
        )
      } else {
        const message = this.checkedList.length
          ? 'Ошибка! Необходимо выбрать только один отчет!'
          : 'Ошибка! Не выбран ни один отчет!'

        this.$message.error(message)
      }
    },
    // перезагрузка списка после изменения в модалках
    changeModal(modal) {
      this[modal] = false
      this.reloadReportsList()
    },
    // удаление отчетов с рендер-функцией
    deleteReport() {
      if (this.checkedList.length) {
        const deletedList = this.reportsList.filter(
          item => this.checkedList.indexOf(item.id) !== -1,
        )
        const h = this.$createElement
        const list = []

        deletedList.forEach(item => {
          list.push(
            h(
              'div',
              {
                style: 'font-size:14px; font-weight: bold; margin-bottom: 5px',
              },
              `№ ${item.id} / ${item.name}`,
            ),
          )
        })
        this.$msgbox({
          message: h('div', { style: "font-family: 'Rubik', sans-serif" }, [
            h(
              'div',
              { style: 'font-size:16px; margin: 20px 0 40px' },
              'Вы уверены, что хотите удалить отчеты?',
            ),
            h('div', { style: 'margin: 10px 0 20px 20px' }, list),
          ]),
          showCancelButton: true,
          confirmButtonText: 'Удалить',
          cancelButtonText: 'Отмена',
          type: 'warning',
        })
          .then(() => {
            ReportsAPI.deleteReports({
              report_ids: this.checkedList,
            })
              .then(() => {
                this.$message.success('Отчеты удалены')
                this.reloadReportsList()
              })
              .catch(err => {
                this.errHandler(err)
              })
          })
          .catch(() => {
          })
      } else {
        this.$message.error('Ошибка! Не выбран ни один документ.')
      }
    },
    // перезагрузка списка отчетов после изменений
    reloadReportsList() {
      this.setCheckedList([])
      this.clearReports([])
      this.clearPagination({})
      const params = this.hasSearchData ? this.searchData : null

      this.$emit('search', params)
    },
  },
}
</script>

<style lang="sass" scoped>
.search-reports-row
  flex-wrap: wrap
  ::v-deep .el-col
    margin-bottom: 20px
    .el-date-editor.el-input
      width: 100%
    input
      height: 52px
    button
      height: 52px
      width: 100%
    &.el-col-lg-5
      width: 20%
</style>
